import { AuthRole } from './auth-role.model';

export class AuthUser {

  constructor(
    private firstName: string,
    private lastname: string,
    private roles: AuthRole[]
    ) { }
}
